/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import React, { useEffect, useState } from 'react'
import './listApps.scss'
import { GetUserApps } from "../../constants/api-urlConstants";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import instance from '../../utils/axiosInstance';
import { CircularProgress } from '@mui/material';
import { accessMangerBasePath, docAcqBasePath, docSearchBasePath, docVerificationBasePath } from "../../constants/env-url";
import { TimerValusSet } from '../../context/TimerContext';

export const ListApps: React.FC<any> = () => {
  const [listData, setListData] = useState<any>([]);
  const [isloading, setIsloading] = useState<any>(false);
  const { setUserHeartBeat, timeExit } = React.useContext(TimerValusSet);

  useEffect(() => {
    localStorage.setItem('currentTab', 'applications');
    getAllApps();
  }, []);

  const openInNewTab = (link: any) => {
    window.open(link, '_blank');
  }

  const goToURL = (row: any) => {
    switch (row.key) {
      case "DOC_VERIFICATION":
        openInNewTab(`${docVerificationBasePath}`)
        // code block
        break;
      case "ACCESS_MANAGER":
        openInNewTab(`${accessMangerBasePath}`)
        break;
      case "DOC_SEARCH":
        openInNewTab(`${docSearchBasePath}`)
        break;
      case "DOC_ACQUISITION":
        openInNewTab(`${docAcqBasePath}`)
        break;
    }
  }

  const getAllApps = () => {
    setIsloading(true);
    const USER_API_BASE_URL = `${GetUserApps}`;
    instance
      .get(USER_API_BASE_URL)
      .then((response) => {
        setIsloading(false);
        setUserHeartBeat(timeExit());
        const res = response.data;
        if (res.success) {
          setListData(res.data);
        }
      })
      .catch((error) => {
      });
  }

  return (
    <div className="list_apps">
      <div className="containerWrapper">
        <div className="listContainerWrapper ">
          {isloading && <div className="tableForappsWrapper">
            <CircularProgress />
          </div>}
          {!isloading && <div className='tableForapps'>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 300 }} aria-label="simple table">
                <TableBody>
                  {listData.map((row: any) => (
                    row.key !== 'REF_DATA' &&
                    <TableRow
                      className='rowButton'
                      key={row.value}
                      onClick={() => goToURL(row)}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        '&:first-of-type td, &:first-of-type th': { borderTop: '1px solid rgba(224, 224, 224, 1)' }
                      }}
                    >
                      {row.key !== 'ACCESS_MANAGER' &&
                        <TableCell component="th" scope="row" width="100px" className='tableText'>
                          {row.value}
                        </TableCell>
                      }
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer></div>}
        </div>
      </div>
    </div>
  )
}